import { Injectable } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class QueryParamsService {
  constructor(private _router: Router, private _route: ActivatedRoute) {}

  changeQueryParams(params: Params) {
    this._router.navigate([], {
      relativeTo: this._route,
      queryParams: params,
      queryParamsHandling: 'merge',
    });
  }

  deleteParam(param: string) {
    const snapshot = this._route.snapshot;
    const params = { ...snapshot.queryParams };
    delete params[param];
    this._router.navigate([], { queryParams: params, relativeTo: this._route });
  }

  deleteParams(params: string[]) {
    const snapshot = this._route.snapshot;
    const nowParams = { ...snapshot.queryParams };
    params.forEach(p => {
      delete nowParams[p];
    });
    this._router.navigate([], {
      queryParams: nowParams,
      relativeTo: this._route,
    });
  }
}
